<template>
  <CModal
    alignment="center"
    :visible="visible"
    @close="
      () => {
        handleAction('cancel')
        visible = false
      }
    "
  >
    <CModalHeader
      dismiss
      @close="
        () => {
          visible = false
        }
      "
    >
      <CModalTitle>{{ title }}</CModalTitle>
    </CModalHeader>
    <CModalBody>
      {{ message }}
    </CModalBody>
    <CModalFooter>
      <CButton
        :color="confirmBtnColor ? confirmBtnColor : 'primary'"
        @click="() => handleAction('confirm')"
      >
        {{ confirmButtonText }}
      </CButton>
      <CButton
        v-if="showCancelButton"
        :color="cancelBtnColor ? cancelBtnColor : 'secondary'"
        @click="() => handleAction('cancel')"
      >
        {{ cancelButtonText }}
      </CButton>
    </CModalFooter>
  </CModal>
</template>

<script>
import { ref } from '@vue/reactivity'
import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CButton,
} from '@coreui/vue'

export default {
  name: 'VerticalCenterModal',
  components: {
    CModal,
    CModalHeader,
    CModalTitle,
    CModalBody,
    CModalFooter,
    CButton,
  },
  setup() {
    const visible = ref(false)
    const title = ref(false)
    const message = ref(false)
    const cancelButtonText = ref(false)
    const confirmButtonText = ref(false)
    const showCancelButton = ref(true)
    const onCancel = ref(() => {})
    const onConfirm = ref(() => {})
    const cancelBtnColor = ref(undefined)
    const confirmBtnColor = ref(undefined)

    const handleAction = (type) => {
      if (type === 'confirm') {
        if (typeof onConfirm.value === 'function') {
          onConfirm.value()
        }
      } else {
        if (typeof onCancel.value === 'function') {
          onCancel.value()
        }
      }
      visible.value = false
    }

    return {
      visible,
      title,
      message,
      cancelButtonText,
      confirmButtonText,
      showCancelButton,
      handleAction,
      onCancel,
      onConfirm,
      cancelBtnColor,
      confirmBtnColor,
    }
  },
}
</script>

<style></style>
